<template>
  <div id="addpaying" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo">Alta Sucursal</v-row>
      <v-row no-gutters class="datos">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="mt-11 mb-2"
        >
          <div class="form-group inputEnterprise">
            <label for="rs" style="width: 10% !important; margin-left: -0.1%"
              >Empresa Pagadora</label
            >
            <select name="suburb" id="suburb" v-model="branchSelect.empresaId">
              <option disabled value="0">Seleccione empresa</option>
              <option
                v-for="enterprise in enterprises"
                :key="enterprise.id"
                v-bind:value="enterprise.id"
              >
                {{ enterprise.razonSocial }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="name">Nombre</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="branchSelect.nombreSucursal"
              required
              maxlength="200"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="telefono">Telefóno</label>
            <input
              type="text"
              name="telefono"
              id="telefono"
              placeholder="55 10 20 30 40"
              autocomplete="false"
              v-model="branchSelect.telefono"
              minlength="10"
              maxlength="10"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <v-checkbox v-model="branchSelect.activo">
            <template v-slot:label>
              <div>Sucursal Activa</div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-5"
          >Domicilio</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="pais">País</label>
            <input
              type="text"
              name="pais"
              id="pais"
              v-model="branchSelect.pais"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="cp">C.P.</label>
            <input
              type="text"
              name="cp"
              id="cp"
              maxlength="5"
              placeholder="Obligatorio"
              required
              autocomplete="false"
              v-model="branchSelect.codigoPostal"
              @keypress="isNumber($event)"
              @change="consultaDireccion()"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="estado">Estado</label>
            <input
              type="text"
              name="estado"
              id="estado"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              maxlength="35"
              v-model="branchSelect.estado"
              readonly
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="municipio">Municipio</label>
            <input
              type="text"
              name="municipio"
              id="municipio"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              v-model="branchSelect.municipio"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="colonia">Colonia</label>

            <select
              name="suburb"
              id="suburb"
              v-model="branchSelect.asentamientoId"
            >
              <option disabled value="0">Selecciona Colonia</option>
              <option
                v-for="suburb in suburbs"
                :key="suburb.id"
                v-bind:value="suburb.id"
              >
                {{ suburb.name }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group inputEnterprise">
            <label for="calle" style="margin-left: 1%; width: 10%">Calle</label>
            <input
              type="text"
              name="calle"
              id="calle"
              v-model="branchSelect.calle"
              maxlength="35"
              required
              autocomplete="false"
              placeholder="Obligatorio"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ne">N° Exterior</label>
            <input
              type="text"
              name="ne"
              id="ne"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              v-model="branchSelect.numeroExterior"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ni">N° Interior</label>
            <input
              type="text"
              name="ni"
              id="ni"
              placeholder="Obligatorio"
              v-model="branchSelect.numeroInterior"
              autocomplete="false"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="450">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Sucursal</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de actualizar la Información de la sucursal?
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="aux()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Sucursal</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "5-N",
      error: false,
      errors: [],
      respuesta: "",
      show:false,
      dialog: false,
      errors: [],
      respuesta: "",
      confirmation: false,
      advice: false,
      error: false,
      country: "México",
      state: "",
      cp: "",
      exterior: "",
      interior: "",
      municipality: "",
      suburb: 0,
      street: "",
      address: [],
      suburbs: [],
      telefono: "",
      name: "",
      enterprise: 0,
      enterprises: [],
      activa: false,
      branchSelect: [],
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    onFileChange(evt) {
      const file = evt.target.files[0];
      this.url = URL.createObjectURL(file);
      var fileBase = evt.target.files[0];
      var reader = new FileReader();
      reader.onloadend = function () {
        console.log("RESULT", reader.result);
        sessionStorage.setItem("base64img", reader.result);
      };
      reader.readAsDataURL(fileBase);
    },
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]+$"); // Letras y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else return true;
    },
    validaImss() {
      var imss = this.imss;
      if (imss.length != 11) {
        this.errors.push("Número de IMSS incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(imss.length);
        return false;
      }
    },
    validaRfc() {
      var strCorrecta;
      strCorrecta = this.rfc;
      if (this.rfc.length == 12) {
        var valid = "^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      } else {
        var valid =
          "^(([A-Z]|[a-z]|s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      }
      var validRfc = new RegExp(valid);
      var matchArray = strCorrecta.match(validRfc);
      if (matchArray == null) {
        this.errors.push("El RFC es incorrecto favor de verificarlo.");
        return false;
      } else {
        console.log("Correcto");
        return true;
      }
    },
    validaCp() {
      console.log(this.branchSelect.codigoPostal);
      var cp = this.branchSelect.codigoPostal;
      if (cp.length != 5) {
        this.errors.push("Código Postal incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(cp.length);
        return false;
      }
    },
    validacion() {
      this.errors = [];
      if (this.branchSelect.name == "" || this.branchSelect.name == " ") {
        this.errors.push("Se debe especificar la Razón Social.");
      }
      if (this.branchSelect.country == "" || this.branchSelect.country == " ") {
        this.errors.push("Se debe especificar el país.");
      }
      this.validaCp();
      if (this.branchSelect.state == "" || this.branchSelect.state == " ") {
        this.errors.push("Se debe especificar el estado.");
      }
      if (
        this.branchSelect.municipality == "" ||
        this.branchSelect.municipality == " "
      ) {
        this.errors.push("Se debe especificar el municipio.");
      }
      if (this.branchSelect.suburb == "" || this.branchSelect.suburb == 0) {
        this.errors.push("Se debe especificar la colonia.");
      }
      if (this.branchSelect.street == "" || this.branchSelect.street == " ") {
        this.errors.push("Se debe especificar la calle.");
      }
      if (this.branchSelect.country == "" || this.branchSelect.country == " ") {
        this.errors.push("Se debe especificar el país.");
      }
      if (this.branchSelect.state == "" || this.branchSelect.state == " ") {
        this.errors.push("Se debe especificar el estado.");
      }
      if (
        this.branchSelect.exterior == "" ||
        this.branchSelect.exterior == " "
      ) {
        this.errors.push("Se debe especificar el número exterior.");
      }
      if (
        this.branchSelect.interior == "" ||
        this.branchSelect.interior == " "
      ) {
        this.errors.push("Se debe especificar el número interior.");
      }

      if (this.branchSelect.phone == "" || this.branchSelect.phone == " ") {
        this.errors.push("Se debe especificar el número interior.");
      }
      if (this.errors.length == 0) {
        return (this.advice = true);
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    regresar() {
      this.enterprise = 0;
      this.telefono = 0;
      this.activa = false;
      this.name = "";
      this.pais = "";
      this.cp = "";
      this.estado = "";
      this.municipio = "";
      this.localidad = "";
      this.colonia = "";
      this.calle = "";
      this.exterior = "";
      this.interior = "";
      this.$router.push("/branchs");
    },
    consultaDireccion() {
      console.log("Consulta dirección");
      console.log(this.branchSelect);
      if (this.branchSelect.codigoPostal.length == 5) {
        this.suburbs = [];
        this.show = true;
        axios
          .get(Server + "/direcciones/" + this.branchSelect.codigoPostal)
          .then((response) => {
            console.log(response);
            this.address = response.data;
            this.branchSelect.estado = this.address[0].estado;
            this.branchSelect.municipio = this.address[0].municipio;
            this.address.forEach((value, index) => {
              this.suburbs.push({
                id: value.asentamientoId,
                name: value.colonia,
              });
            });
            this.show = false;
          })
          .catch((e) => {
            console.log(e);
            this.show = false;
          });
      } else {
        console.log("Menor a 5");
      }
    },
    aux() {
      this.confirmation = false;
      this.enterprise = 0;
      this.telefono = "";
      this.name = "";
      this.activa = false;
      this.country = "";
      this.cp = "";
      this.state = "";
      this.municipality = "";
      this.suburb = "";
      this.exterior = "";
      this.interior = "";
      this.street = "";
      this.$router.push("/branchs");
    },
    guardar() {
      this.advice = false;
      console.log("llegue");
      var logo = null;
      if (sessionStorage.getItem("base64img") == "null") {
        logo = this.branchSelect.logo;
      } else {
        logo = sessionStorage.getItem("base64img");
      }
      this.show = true;
      axios
        .put(Server + "/sucursales/" + this.branchSelect.id, {
          Id: this.branchSelect.id,
          EmpresaId: this.branchSelect.empresaId,
          NombreSucursal: this.branchSelect.nombreSucursal,
          Telefono: parseInt(this.branchSelect.telefono),
          Pais: this.branchSelect.pais,
          CodigoPostal: this.branchSelect.codigoPostal,
          AsentamientoId: this.branchSelect.asentamientoId,
          NumeroExterior: this.branchSelect.numeroExterior,
          NumeroInterior: this.branchSelect.numeroInterior,
          Calle: this.branchSelect.calle,
          Activo: this.branchSelect.activo,
        })
        .then((response) => {
          console.log(response);
          this.respuesta = "La Sucursal fue guardada con éxito";
          this.confirmation = true;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.respuesta = "La Sucursal no fue almacenada";
          this.confirmation = true;
          this.show = false;
        });
    },
    cancel() {
      this.enterprise = 0;
      this.telefono = "";
      this.activa = false;
      this.name = "";
      this.country = "";
      this.cp = "";
      this.state = "";
      this.municipality = "";
      this.suburb = "";
      this.exterior = "";
      this.interior = "";
      this.street = "";
      this.$router.push("/branchs");
    },
    recuperar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          //console.log("Resultado de empresas");
          //console.log(response);
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
      //console.log(localStorage.sucursalId);
      this.show = true;
      axios
        .get(Server + "/sucursales/" + localStorage.sucursalId)
        .then((response) => {
          console.log(response);
          this.branchSelect = response.data;
          localStorage.sucursalId = "";
          this.consultaDireccion();
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
  },
  created() {
    this.nombre();
    this.recuperar();
  },
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
</style>
